import { GenericForm } from '@neo/blocks/forms/generic-form'
import { Button, ButtonWithLoader } from '@neo/index'
import { DialogFooter } from '@neo/primitives/dialog'
import { Typography } from '@neo/primitives/typography'
import { professionalVoicesDefaultValues, professionalVoicesFields } from '../custom-voice.config'
import type { ProfessionalVoicesFormValues } from '../custom-voice.types'

interface ProfessionalVoicesTabProps {
  onCancel: () => void
  onSubmit: (values: ProfessionalVoicesFormValues) => void
  isSubmitting?: boolean
}

export const ProfessionalVoicesTab = ({
  onCancel,
  onSubmit,
  isSubmitting = false,
}: ProfessionalVoicesTabProps) => {
  return (
    <div className="pt-4">
      <Typography variant="S/400" className="text-secondary">
        Import professional-grade voices using ElevenLabs share links.
      </Typography>
      <Typography variant="XS/400" className="text-tertiary mb-4">
        Paste a voice share link from ElevenLabs voice lab.
      </Typography>
      <GenericForm<ProfessionalVoicesFormValues>
        fields={professionalVoicesFields}
        defaultValues={professionalVoicesDefaultValues}
        onSubmit={onSubmit}
        includeSubmitButton={false}
        id="professional-voices-form"
      />
      <DialogFooter className="mt-6 flex flex-row sm:justify-between">
        <Button
          type="button"
          variant="outline"
          onClick={onCancel}
          disabled={isSubmitting}
          data-testid="button-cancel-professional-voices"
        >
          Cancel
        </Button>
        <ButtonWithLoader
          form="professional-voices-form"
          type="submit"
          loading={isSubmitting}
          disabled={isSubmitting}
          data-testid="button-import-professional-voice"
        >
          Add Voice
        </ButtonWithLoader>
      </DialogFooter>
    </div>
  )
}
